<template>
  <div>
    <blockquote v-html="review.revieweeUserAssignment.reviewQuestion.response"></blockquote>
    <ul>
      <li v-for="(criteriaItem, criteriaIndex) in review.rubrics.criteria">
        <p v-if="review.rubrics.criteria.length > 1">{{criteriaItem.name}}:</p>
        <ratings :range="review.rubrics.scoreRange" :name="'rating-'+review.revieweeUserAssignmentId+'-'+criteriaIndex" v-model="review.ratings[criteriaIndex]" @input="updateRatings(ratings)" :stars="review.rubrics.criteria.length == 1" />
      </li>
    </ul>
    <textarea-autogrow placeholder="Begin typing..." v-model="review.review" />
    <btn @click.prevent="saveReview" :disabled="!reviewIsValid">Save Review</btn>
  </div>
</template>

<script>

  export default {
    name: 'RatePeer',
    props: {
      review: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        ratings: this.review.ratings,
        inProgressInterval: null
      }
    },
    created () {
      this.setInProgress()
      this.inProgressInterval = setInterval(() => {
        this.setInProgress()
      }, (4 * 60 * 1000))
    },
    destroyed () {
      clearInterval(this.inProgressInterval)
    },
    computed: {
      reviewIsValid () {
        return _.compact(this.ratings).length == this.review.rubrics.criteria.length
      }
    },
    methods: {
      updateRatings (ratings) {
        this.ratings = ratings
      },
      saveReview () {
        this.review.state = 'completed'
        this.$emit('submit')
      },
      setInProgress () {
        this.review.DSUpdate({ state: "in-progress" }, { cacheResponse: false })
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @import "~globals";

  ul {
    @include list-style-reset;
    margin:4rem 0;
  }

  li + li {
    margin-top:2rem;
  }

  p {
    margin-bottom:1rem;
  }

  .ratings {
    @include checkboxes;
  }

  blockquote {
    margin-top:0!important;
    word-wrap:break-word;
  }

  textarea {
    margin-bottom:2rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/_global/rate-peer.vue